<template>
    <div v-bind:class="{basket:true}">
        <div class="basket2">
          <!-- <div class="title"><i class="fas fa-shopping-cart"></i>&nbsp;YOUR BASKET</div> -->
          <!-- <div class="list" v-if="!isDiverseBasket">
              <div v-bind:class="{item:true}" v-bind:key="'item'+index" v-for="(item,index) in basket" v-on:click="item.data.showDetails=!item.data.showDetails">
                  <div class="image" v-bind:style="{'background-image':'url('+item.data.service.url+')'}" v-if="item.type===1"></div>
                  <div class="details service" v-if="item.type===1">
                      <div class="name">{{item.data.service.name}}</div>
                      <div class="details" v-show="item.data.showDetails">{{item.data.service.details}}</div>
                      <div class="details">{{item.data.teammember.name}}</div>
                  </div>
                  <div class="details giftcard" v-if="item.type===2">
                      <div class="name">Giftcard {{item.data.denomination.Name}}</div>
                      <div class="details">Value: <span class="price"><span class="currency">{{parameters.Currency}}</span>{{item.data.denomination.FaceValue}}</span><span class="price" v-if="item.data.denomination.ActualValue!=item.data.denomination.FaceValue"> / <span class="currency">{{parameters.Currency}}</span>{{item.data.denomination.ActualValue}}</span></div>
                  </div>
                  <div class="remove" v-on:click.stop="removeItemFromBasket(item)"><i class="fas fa-trash"></i></div>
              </div>
              <div class="controls" v-if="type===1">
                  <button v-on:click="setServicesToStepZero()">ADD ANOTHER SERVICE</button>
              </div>
          </div> -->
          <div class="list" v-if="itemsInBasket>0">
              <template v-for="type in types">
                  <div class="title" v-if="isDiverseBasket&&itemTypeInBasket(type)"><span v-if="type===1">Services</span><span v-if="type===3">Products</span></div>
                  <div v-bind:class="{item:true}" v-bind:key="getTypeString(type)+index" v-for="(item,index) in basket" v-on:click="item.data.showDetails=!item.data.showDetails" v-if="item.type===type&&type!=2">
                      <div class="image" v-bind:style="{'background-image':'url('+item.data.service.url+')'}" v-if="item.type===1"></div>
                      <div class="image" v-bind:style="{'background-image':'url('+parameters.GiftcardImageLink+')'}" v-if="item.type===2"></div>
                      <div class="image" v-bind:style="{'background-image':'url('+item.data.product.SmallImage+')'}" v-if="item.type===3"></div>
                      <div class="details service" v-if="item.type===1">
                          <div class="name">{{item.data.service.name}}</div>
                          <div class="details" v-show="item.data.showDetails">{{item.data.service.details}}</div>
                          <div class="details">{{item.data.teammember.name}}</div>
                      </div>
                      <div class="details giftcard" v-if="item.type===2">
                          <div class="name"><span v-if="item.data.denomination.Name">{{item.data.denomination.Name}} &bull; </span><span class="value">Value: <span class="price"><span class="currency">{{parameters.Currency}}</span>{{item.data.denomination.FaceValue}}</span><span class="price" v-if="item.data.denomination.ActualValue!=item.data.denomination.FaceValue"> / <span class="currency">{{parameters.Currency}}</span>{{item.data.denomination.ActualValue}}</span></span></div>
                          <div class="details">Price: <span class="price"><span class="currency">{{parameters.Currency}}</span>{{getDenominationPrice(item).toFixed(2)}}</span></div>
                          <div class="details" v-if="item.data.sendData!=null" style="font-size:0.7em;">This giftcard is for <span v-if="item.data.sendData.to!=''"><b>{{item.data.sendData.to}}</b></span><span v-else>you</span>.</div>
                      </div>
                      <div class="details product" v-if="item.type===3">
                          <div class="name">{{item.data.product.Title}}</div>
                          <div class="details">Quantity: <b>{{item.data.quantity}}</b> &bull; Price: <span class="price"><span class="currency">{{parameters.Currency}}</span>{{item.data.product.RRP.toFixed(2)}}</span></div>
                      </div>
                      <div class="remove" v-on:click.stop="removeItemFromBasket(item)"><i class="fas fa-trash"></i></div>
                  </div>
                  <div class="controls" v-if="type===1&&itemTypeInBasket(type)">
                      <button v-on:click="setServicesToStepZero()">ADD ANOTHER SERVICE</button>
                  </div>
              </template>
          </div>
          <div class="controls end">
              <span class="itemcount" v-if="itemsInBasket===0">Basket is empty</span>
              <span class="itemcount" v-if="itemsInBasket>0">{{itemsInBasket}} item<span v-if="itemsInBasket>1">s</span> &bull; <span><span class="currency">{{parameters.Currency}}</span>{{total.toFixed(2)}}</span></span>
              <button v-bind:class="{disabled:itemsInBasket===0}" v-on:click="goToCheckout()" v-if="itemsInBasket>0">Checkout</button>
          </div>
        </div>
        <!-- <div v-bind:class="{basketicon:true,open:basketOn}" v-show="isMobile" v-on:click="toggleBasket()">
          <i class="fas fa-shopping-cart" v-show="!basketOn"></i>
          <i class="fas fa-times" v-show="basketOn"></i>
          <div class="bubble" v-show="!basketOn">{{itemsInBasket}}</div>
        </div> -->
    </div>
</template>

<script>

import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import lodash from "lodash/lodash.min.js";

export default {
    name: 'Basket',
    props: [
        "options"
    ],
    data () {
        return {
            types: [1,2,3]
        }
    },
    computed: lodash.assign(
        mapGetters({
            EventBus: "get_eventbus",
            windowWidth: "get_windowwidth",
            basket: "get_basket",
            isMobile: "get_ismobile",
            basketOn: "get_basketon",
            parameters: "get_parameters",
            denominations: "get_denominations",
            isAuthorised: "get_isauthorised"
        }),
        {
            itemsInBasket () {
                var totalProducts = 0;
                this.basket.map( (a) => { totalProducts += a.type!= 2 ? a.data.quantity : 0; });
                return totalProducts;
            },
            showBasket () {
                //if(!this.isMobile) return true;
                return this.basketOn;
            },
            isDiverseBasket () {
                if(this.basket.length < 2) return false;
                var typ = this.basket[0].type;
                var div = false;
                for(var i=0; i<this.basket.length; i++) {
                    if(this.basket[i].type == 2) continue;
                    if(typ!=2 && typ != this.basket[i].type) {
                        div = true;
                        break;
                    }
                }
                return div;
            },
            total () {
                var total = 0;
                for(var i=0; i<this.basket.length; i++) {
                    //if(this.basket[i].type === 2) total += this.basket[i].data.denomination.ActualValue + this.parameters.GiftcardOtherCharge1;
                    if(this.basket[i].type === 3) total += this.basket[i].data.product.RRP * this.basket[i].data.quantity;
                }
                return total;
            }
        }
    ),
    methods: {
        getDenominationPrice (item) {
            return item.data.denomination.ActualValue;// + this.parameters.GiftcardOtherCharge1;
        },
        getTypeString (type) {
            return type === 1 ? "service" : (type === 2 ? "giftcard" : "product");
        },
        itemTypeInBasket (type) {
            return typeof this.basket.find(function(a){return a.type === type}) != "undefined";
        },
        setServicesToStepZero() {
            this.$emit("resetservices",{});
            this.toggleBasket();
        },
        goToCheckout () {
            this.EventBus.$emit("showBasket",false);
            // if(this.$route.name == "giftcards") {
            //     //this.$router.replace({name:"giftcards",params:{step:3}});
            //     this.EventBus.$emit("giftcardsGoToCheckout");
            //     return;
            // }
            if(!this.isAuthorised) this.$store.commit("set_desiredpage","checkout");
            this.$emit("gotocheckout",{});
        },
        toggleBasket () {
            this.$store.dispatch("setBasketOn",!this.basketOn);
        },
        removeItemFromBasket (item) {
            item.data.quantity--;
            if(item.data.quantity == 0) {
                this.$store.dispatch("removeItemFromBasket",item);
                this.$emit("basketsizechanged",{});
            }
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../scss/_hub-sass-common-functions.scss";

    .basket {
        //width: 0;
        //height: 0;
        margin: 60px 0 0 0;
        position: fixed;
        right:0;
        top:0;
        display: flex;
        z-index: 2;
        max-width: 320px;
        min-width: 320px;
        width: 320px;
        height:auto;
        max-height: calc(100% - 70px);
        &.on {
            width: calc(25% - 40px);
            //height: calc(100% - 113px);
            height:auto;
        }
    }
    .basket2 {
        width: 100%;
        background-color: white;
        //border-radius: 5px;
        //height:calc(100% - 0px);
        overflow: hidden;
        display: flex;
        flex-direction: column;
        box-shadow: 0 5px 5px rgba(0,0,0,0.3);
        & > .title {
            padding:20px;
            height:60px;
            background-color: $panelTitleBackgroundColour;
            color: $panelTitleTextColour;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex:0 0 auto;
            box-sizing: border-box;
            & i {
                font-size: 30px;
                margin-right: 10px;
            }
        }
        & .list {
            //padding:10px;
            margin-top:0;
            overflow-y: auto;
            height: 100%;
            display: flex;
            flex-direction: column;
            border-bottom:1px solid #b3b3b3;
            //padding-bottom: 20px;
            padding:10px 0 0 0;
            //max-height: 300px;
            overflow-y: auto;
            & .title {
                //border-top:1px solid #565656;
                padding:0 10px 10px 10px;
                display: flex;
                justify-content: flex-start;
                align-items: center
                //background-color: #565656;
                //margin-top:20px;
                &:first-child {
                    margin-top: 0;
                }
            }
            & .item {
                // position: relative;
                // display: flex;
                // margin:0 10px 10px 10px;
                // background-color: rgba(0,0,0,0.2);
                // width:calc(100% - 20px);
                // cursor:pointer;
                // transition: all 0.25s ease, transform 0.25s ease;
                // overflow:hidden;
                // flex:0 0 auto;
                background-color: rgba(0, 0, 0, 0.05);
                border-radius: 5px;
                width:calc(100% - 20px);
                display: flex;
                overflow: hidden;
                flex:0 0 auto;
                margin:0 10px 10px 10px;
                & .image {
                    width:50px;
                    height:50px;
                    margin:10px;
                    flex:0 0 auto;
                    background-color: white;
                    background-position: center center;
                    background-repeat: no-repeat;
                    background-size: cover;
                }
                & > .details {
                    width:100%;
                    display: flex;
                    flex-wrap: wrap;
                    flex-direction: column;
                    justify-content: space-between;
                    & .name {
                        padding:5px 5px 5px 0;
                        font-size:0.8em;
                        font-weight:bold;
                        text-align: left;
                    }
                    & .details {
                        font-size:0.8em;
                        text-align: left;
                        padding:0 10px 10px 0;
                        & .price {
                            font-size:inherit;
                        }
                    }
                    &.giftcard, &.product {
                        & .name, & .details {
                            padding-left:10px;
                            & .price {
                                font-size:inherit;
                            }
                        }
                    }
                }
                & .remove {
                    width:40px;
                    display:flex;
                    justify-content: center;
                    align-items: flex-end;
                    //background-color: #323232;
                    color: #323232;
                    flex:0 0 auto;
                    padding-bottom: 15px;
                    cursor:pointer;
                }
                &:hover {
                    //background-color: orange;
                    //transform: scale(1.02);
                    //box-shadow: 0 4px 8px rgba(0,0,0,0.5);
                }
            }
        }
        & .controls {
            padding:20px 20px 0 20px;
            margin-bottom: 20px;
            text-align: right;
            & button {
                border: none;
                padding: 10px;
                font-size: 1em;
                //border-radius: 5px;
                //background-color: $buttonBackgroundColour;
                //color: $buttonTextColour;
                //box-shadow: 0 4px 8px rgba(0,0,0,0.5);
                cursor:pointer;
                transition:all 0.1s ease;
                &:hover {
                    box-shadow: none;
                }
                &.disabled {
                    opacity: 0.5;
                    pointer-events: none;
                }
            }
            &.end {
                min-height: 60px;
                max-height: 60px;
                //background-color: $panelTitleBackgroundColour;
                //border-top:1px solid #565656;
                padding: 10px;
                margin-bottom: 0;
                display: flex;
                justify-content: space-between;
                align-items: center;
                & .itemcount {
                    //color: $panelTitleTextColour;
                }
                box-sizing: border-box;
            }
        }
    }

    .basketicon {
        background-color: orange;
        width:60px;
        height:60px;
        position: fixed;
        bottom:20px;
        right: 20px;
        display:flex;
        align-items: center;
        justify-content: center;
        border-radius:50%;
        color: rgb(50,50,50);
        font-size:25px;
        //box-shadow: 0 4px 8px rgba(0,0,0,0.5);
        transition:all 0.25s ease;
        cursor:pointer;
        z-index: 2;
        & .bubble {
            position:absolute;
            top:-6px;
            right:-6px;
            background-color: red;
            width: 28px;
            height:28px;
            font-size:16px;
            font-weight: bold;
            color:white;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
        }
        &:hover {
            box-shadow: none;
            background-color: rgb(50,50,50);
            color: orange;
        }
        &.open {
            background-color: transparent;
            box-shadow: none;
            color:orange;
        }

    }


    @media only screen and (max-width: 1600px) {
        .basket {
            &.on {
                width: calc(25% - 0px);
            }
        }
    }

    @media only screen and (max-width: 1230px) {
        .basket {
            margin: 40px 0 0 0;
        }
    }

    @media only screen and (max-width: 1024px) {
        .basket {
            margin: 30px 0 0 0;
            max-height: calc(100% - 40px);
        //     margin:10px 10px 10px 0;
        //     height:calc(100% - 20px);
        //     &.on {
        //         width: calc(34% + 10px);
        //         height:calc(100% - 20px);
        //     }
        //     & .controls {
        //         & button {
        //             padding:10px;
        //         }
        //     }
        }
    }

    @media only screen and (max-width: 768px) {
        .basket {
            // position:fixed;
            // z-index: 1;
            // bottom:20px;
            // right:20px;
            // margin:0;
            // border-bottom-right-radius: 30px;
            // &.on {
            //     width: 80%;
            //     height:calc(100% - 40px);
            // }
        }
        .basket2 {
            & .controls {
                & button {
                    //margin-right:40px;
                }
            }
        }
    }

    @media only screen and (max-width: 450px) {
    }
</style>
